<script lang="ts">
    import { faEllipsisV, faComment, faCopy, faFileSignature, faPenNib, faShoppingCart, faSign, faUser } from '@fortawesome/free-solid-svg-icons'
    import Fa from 'svelte-fa'
    import type { Appointment } from '../../../modules/schedulerApi/appointments/appointment'
    import dayjs from 'dayjs'
    import utc from 'dayjs/plugin/utc'
    import 'dayjs/locale/pt-br'
    dayjs.locale('pt-br')
    import { createEventDispatcher, onMount } from 'svelte'
    import { AppointmentStatus, AppointmentStatusFriendly } from '../../../modules/schedulerApi/appointments/appointments.enum'
    import Popover from '../../_common/popover.svelte'
    import { blur } from 'svelte/transition'
    import AppointmentSign from '../appointment-sign.svelte'
    import type { ZdropInterface } from '../../_common/z/zdrop.interface'
    import Zdrop from '../../_common/z/zdrop.svelte'
    const dispatch = createEventDispatcher()

    let notChargedStatus = ['agendamento_remarcado', 'agendamento_cancelado_usuario', 'agendamento_cancelado_empresa', 'agendamento_excluido']

    export let item: { position: number; shared: number; appointment: Appointment }
    export let firstTime: number = 0
    export let showTime = true
    export let heightPerMinute: number
    export let clear = false
    export let list: boolean = false
    export let blink: boolean = false

    // Celular ou desktop decide tanto o que é desenhado (menu suspenso x fila de botões) quanto o
    // comportamento de hover, antes resolvidos por largura (h-mobile/h-full e @media 900px). Largura
    // não é o critério certo: uma janela estreita no desktop tem mouse e merece o hover, e um tablet
    // largo não tem. Como a classe entra no bloco, o CSS acompanha a mesma decisão.
    const isMobile = window.api.utils.utils.isMobile()

    let minimalMinuteAllowed = 10
    let minutes = 0
    let factor = 0
    let height = 0
    let setAttended = !!window.configs.scheduleAutoCommitStatus

    // a badge de status é a primeira linha de conteúdo (na mesma faixa das marcações), então a altura
    // necessária é cabeçalho (~19px) + faixa das badges (~20px) + respiro. Abaixo disso ela seria
    // cortada pelo overflow:hidden do bloco, então nem é renderizada.
    const MIN_HEIGHT_TO_SHOW_STATUS = 48
    let statusLabel = ''
    let showStatusBadge = false

    // baixado ('*') e pago (invoiceId real) são o mesmo conceito: o atendimento já foi liquidado
    $: isSettled = item.appointment.invoiceId === '*' || item.appointment.invoiceId?.length >= 10

    minutes = 0
    factor = 0
    height = 0

    let selected = false

    $: {
        if (clear) selected = false
        loadAppointment(item, firstTime, heightPerMinute)
    }

    let haveComission = false
    function checkComission() {
        for (const i of item.appointment.items) {
            if (i.comissionCosts > 0 || i.comissionFixed > 0 || i.comissionPercentage > 0) {
                haveComission = true
                return
            }
        }
    }

    let slotStyle = ''
    function loadAppointment(i, firstTime, heightPerMinute) {
        slotStyle = ''
        // bloqueado não tem status "de agendamento" para exibir — o próprio título já diz "Bloqueado"
        statusLabel = i.appointment.status === AppointmentStatus.agendamento_bloqueado ? '' : AppointmentStatusFriendly[i.appointment.status] || ''
        if (!list) {
            // determina altura do box
            height = 0
            minimalMinuteAllowed = 10
            minutes = 0
            factor = 0
            minutes = (+i.appointment.end - +i.appointment.start) / 1000 / 60
            factor = minutes / minimalMinuteAllowed
            height = heightPerMinute * minutes
            if (height === 0) height = 15

            // determina posição do box, caso seja slot, e não formato list

            let width = 0
            let widthDiscount = 0
            let left = 0
            let leftDiscount = 0
            let top = 0
            width = 100 / i.shared
            widthDiscount = 30 / i.shared
            left = 100 - 100 / i.position
            left = (100 / i.shared) * (i.position - 1)
            leftDiscount = widthDiscount * (i.position - 1)
            top = (i.appointment.start.getHours() * 60 + i.appointment.start.getMinutes() - firstTime) * heightPerMinute

            // --slot-h: a mesma altura, disponível para o CSS — no hover o bloco passa a crescer com o conteúdo
            // (height: auto) e usa esse valor como piso, para nunca encolher embaixo do mouse
            // interpolate-size: deixa o crescimento até "auto" animar (Chrome/Electron recentes; nos demais o
            // bloco só aparece no tamanho final). Vai inline porque o svelte-check ainda não reconhece a
            // propriedade e acusaria um aviso falso na folha de estilos do componente.
            // (não escrever a tag de estilo literal em comentário do script: o pré-processador a procura
            // por texto e toma o comentário pelo início do CSS)
            slotStyle = 'height:' + (height - 4) + 'px;--slot-h:' + (height - 4) + 'px;interpolate-size:allow-keywords;'
            slotStyle +=
                'top:' + (top + 2) + 'px;left:calc(' + (left + 2) + '% - ' + leftDiscount + 'px);width:calc(' + (width - 2) + '% - ' + widthDiscount + 'px);'
            showStatusBadge = !!statusLabel && height >= MIN_HEIGHT_TO_SHOW_STATUS
        } else {
            slotStyle = 'position:relative;'
            // na visão Lista o bloco cresce com o conteúdo, então não há restrição de altura
            showStatusBadge = !!statusLabel
        }

        checkComission()
        checkWidth()
    }

    function hour(ap) {
        return ap.start.getMinutes() === 0
    }

    function bold(ap) {
        return ap.status !== 'agendamento_disponivel'
    }

    function onMouseDown(el) {
        selected = !selected
    }

    function onMouseOut(ev) {
        ev.target.scrollTop = 0
    }

    async function showEdit(event) {
        if (!item.appointment.appointmentId) return
        await hydrateServices()
        if (item.appointment.status === AppointmentStatus.agendamento_bloqueado) {
            dispatch('edit-block', item.appointment)
        } else {
            dispatch('edit', item.appointment)
        }
    }

    function showPerson(event) {
        window.person('show', item.appointment.personId, 2)
    }

    let goInvoiceQuestion = false
    function goInvoice() {
        goInvoiceQuestion = true
    }

    async function hydrateServices() {
        item.appointment.items = await window.api.utils.utils.assignServicesFromObject(item.appointment.items)
    }

    async function newInvoice() {
        goInvoiceQuestion = false
        await hydrateServices()
        dispatch('invoice', { appointment: item.appointment, act: 'add', attended: setAttended })
    }

    async function editInvoice() {
        goInvoiceQuestion = false
        await hydrateServices()
        dispatch('invoice', { appointment: item.appointment, act: 'edit', attended: setAttended })
    }

    async function setOpen() {
        goInvoiceQuestion = false
        await hydrateServices()
        dispatch('invoice', { appointment: item.appointment, act: 'open', attended: setAttended })
    }

    async function setOpenAlert() {
        if (!confirm("Atenção: Cancelar a baixa não exclui o lançamento no PDV, apenas altera o status deste agendamento para 'em aberto'. Deseja continuar?"))
            return
        goInvoiceQuestion = false
        await hydrateServices()
        dispatch('invoice', { appointment: item.appointment, act: 'open', attended: setAttended })
    }

    async function setClosed() {
        goInvoiceQuestion = false
        await hydrateServices()
        dispatch('invoice', { appointment: item.appointment, act: 'closed', attended: setAttended })
    }

    async function setClosedNoComission() {
        if (haveComission && !confirm('O atendente não receberá comissão por este atendimento.')) return
        goInvoiceQuestion = false
        await hydrateServices()
        dispatch('invoice', { appointment: item.appointment, act: 'closed-nocomission', attended: setAttended })
    }

    let copied = false
    function goCopy(cut: boolean = false) {
        console.log('cutting', cut, item.appointment)
        //copied = true
        window.$.copy = {
            source: Object.assign({}, item.appointment),
            cut: cut,
        }
    }

    let off = false
    function onDragStart(event) {
        console.log('dragstart', event)
        let extraMargin = vertical ? 30 : 88
        if (off || event.offsetY > 22 || event.offsetX > event.target.clientWidth - extraMargin) {
            event.preventDefault()
            return false
        }
        goCopy(true)
        console.log('started')
    }
    function onDragEnd(event) {
        //window.$.copy = null
    }

    let small = false
    let vertical = false
    onMount(() => {
        checkWidth()
    })
    function checkWidth() {
        const self = document.getElementById('e_' + item.appointment.appointmentId)
        small = self?.clientWidth <= 110
        vertical = self?.clientWidth <= 110 && self?.clientHeight > self?.clientWidth
    }

    let goSignQuestion: boolean = false
    function goSign() {
        goSignQuestion = true
    }

    function goSigned() {
        goSignQuestion = false
        // o componente de assinatura só dispara "close" depois de gravar a assinatura — reflete na hora, sem
        // esperar recarregar a agenda (as outras telas abertas atualizam pelo aviso de agenda alterada do scheduler-api)
        item.appointment.signed = true
        item = item
    }

    const actionMenu: ZdropInterface = {
        format: 'square',
        position: 'flow',
        positionMargin: '4px',
        icon: faEllipsisV,
        buttons: [],
    }

    if (item.appointment.appointmentId && item.appointment.status !== AppointmentStatus.agendamento_bloqueado) {
        actionMenu.buttons.push({
            callback: goSign,
            label: 'Assinar',
            icon: faFileSignature,
        })

        if (window.store.token.permissions.pos.show && window.store.token.permissions.pos.sales.write) {
            actionMenu.buttons.push({
                callback: goInvoice,
                label: 'Pagamento',
                icon: faShoppingCart,
            })
        }
    }

    actionMenu.buttons.push({
        callback: () => goCopy(false),
        label: 'Copiar',
        icon: faCopy,
    })

    if (item.appointment.appointmentId && item.appointment.status !== AppointmentStatus.agendamento_bloqueado && window.store.token.permissions.persons.show) {
        actionMenu.buttons.push({
            callback: showPerson,
            label: 'Pessoa',
            icon: faUser,
        })
    }
</script>

{#if goSignQuestion}
    <Popover title="Assinatura" width="860px" height="460px" on:close={() => (goSignQuestion = false)}>
        <AppointmentSign on:close={goSigned} appointmentId={item.appointment.appointmentId}></AppointmentSign>
    </Popover>
{/if}

{#if goInvoiceQuestion}
    <Popover title="O que você deseja fazer?" width="560px" height="160px" on:close={() => (goInvoiceQuestion = false)}>
        <div class="config-box m-3">
            <div class="apselect_status mb-3">
                <div class="spacer"></div>
                <div class="form-check form-switch">
                    <input class="form-check-input" bind:checked={setAttended} type="checkbox" role="switch" id="consulting" />
                    <label class="form-check-label" for="consulting">Ao salvar mudar agendamento para "Compareceu"</label>
                </div>
            </div>
            <div class="go-invoice">
                {#if item.appointment.invoiceId?.length >= 10}
                    <button class="btn btn-secondary" on:click={editInvoice}>Editar pagamento no PDV</button>
                    <button on:click={setOpenAlert} class="btn btn-secondary">Cancelar baixa</button>
                {:else}
                    <button on:click={newInvoice} class="btn btn-secondary">Lançar pagamento no PDV</button>
                    {#if item.appointment.invoiceId === null}
                        <button on:click={setClosed} class="btn btn-secondary">Dar baixa sem lançar no PDV</button>
                        {#if haveComission}
                            <button on:click={setClosedNoComission} class="btn btn-secondary">Dar baixa sem lançar e não pagar comissão</button>
                        {/if}
                    {:else}
                        <button on:click={setOpen} class="btn btn-secondary">Cancelar baixa</button>
                    {/if}
                {/if}
            </div>
        </div>
    </Popover>
{/if}

<!-- O 1 extra no style abaixo é para compensar a border-bottom:1px -->
<div
    in:blur={{ delay: 150, duration: 200 }}
    out:blur={{ duration: 300 }}
    on:mouseleave|stopPropagation={onMouseOut}
    on:blur={() => null}
    on:mousedown|stopPropagation={onMouseDown}
    class="ap-item schedule-item scroll-dark {item.appointment.status} appointment_source_{item.appointment.source}"
    id="e_{item.appointment.appointmentId}"
    class:selected
    class:copied
    class:hour={hour(item.appointment)}
    class:ap-item-bold={bold(item.appointment)}
    class:small
    class:ap-item-is-list={list}
    class:is-mobile={isMobile}
    class:blink
    style={slotStyle}
    on:click|stopPropagation={showEdit}
    draggable="true"
    on:dragend|stopPropagation={onDragEnd}
    on:dragstart|stopPropagation={onDragStart}
>
    {#if isMobile}
        <div class="act">
            <Zdrop menu={actionMenu}></Zdrop>
        </div>
    {:else}
        <div class="act" class:vertical>
            {#if item.appointment.appointmentId && item.appointment.status !== AppointmentStatus.agendamento_bloqueado}
                <button title="Assinatura" class:signed={item.appointment.signed} on:mousedown|stopPropagation on:click|stopPropagation={() => goSign()}>
                    <Fa icon={faFileSignature} />
                </button>
            {/if}
            {#if window.store.token.permissions.pos.show && window.store.token.permissions.pos.sales.write}
                {#if item.appointment.appointmentId && item.appointment.status !== AppointmentStatus.agendamento_bloqueado}
                    <button
                        title={isSettled ? 'Baixa lançada' : 'Lançar recebimento'}
                        class:settled={isSettled}
                        on:mousedown|stopPropagation
                        on:click|stopPropagation={() => goInvoice()}
                    >
                        <Fa icon={faShoppingCart} />
                    </button>
                {/if}
            {/if}

            <button title="Copiar agendamento" on:click|stopPropagation={() => goCopy(false)}>
                <Fa icon={faCopy} />
            </button>

            {#if item.appointment.appointmentId && item.appointment.status !== AppointmentStatus.agendamento_bloqueado}
                <!-- <button on:mousedown|stopPropagation on:click|stopPropagation={showEdit}>
                    <Fa icon={faPenNib} />
                </button> -->
                {#if window.store.token.permissions.persons.show}
                    <button title="Ver ficha da pessoa" on:mousedown|stopPropagation on:click|stopPropagation={showPerson}>
                        <Fa icon={faUser} />
                    </button>
                {/if}
            {/if}
        </div>
    {/if}

    <!-- <div class="header" on:click|stopPropagation> -->
    <div class="ap-item_header">
        {#if showTime}
            <span class="ap-item_time">{dayjs(item.appointment.start).format('HH:mm')} - {dayjs(item.appointment.end).format('HH:mm')}</span>
        {/if}
        <span class="ap-item_name">
            {#if item.appointment.status === AppointmentStatus.agendamento_bloqueado}
                Bloqueado
            {:else if item.appointment?.person?.name}
                {item.appointment?.person?.name || ''}
            {/if}
        </span>
    </div>
    {#if bold(item.appointment)}
        <div class="extra">
            <div class="-icons">
                {#if item.appointment.invoiceId === '*'}
                    <span class="notes-badge -settled">
                        <Fa icon={faShoppingCart} /><span class="-txt">baixado</span>
                    </span>
                {/if}
                {#if item.appointment.signed}
                    <span class="notes-badge">
                        <Fa icon={faFileSignature} /><span class="-txt">assinado</span>
                    </span>
                {/if}
                {#if item.appointment.invoiceId?.length >= 10}
                    <span class="notes-badge -settled">
                        <Fa icon={faShoppingCart} /><span class="-txt">pago</span>
                    </span>
                {/if}
                {#if showStatusBadge}
                    <span class="ap-status-badge">{statusLabel}</span>
                {/if}
            </div>
            {#if item.appointment.notes}
                <div class="notes">
                    <Fa icon={faComment} />{item.appointment.notes}
                </div>
            {/if}
            {#if item.appointment.groupTotal > 1}
                <div
                    class="notes-badge"
                    class:-not-charged={notChargedStatus.includes(item.appointment.status)}
                    title={notChargedStatus.includes(item.appointment.status) ? 'Não descontado do cliente' : ''}
                >
                    {item.appointment.groupPos} de {item.appointment.groupTotal} ag. recorrentes
                </div>
            {/if}
            <div class="services">
                {#if !!item.appointment.items}
                    {#each item.appointment.items as el}
                        <div class="item">
                            {#if el.parentServicesOnInvoicesId}
                                {#if el.groupTotal > 1}
                                    <div
                                        class="notes-badge"
                                        class:-not-charged={notChargedStatus.includes(item.appointment.status)}
                                        title={notChargedStatus.includes(item.appointment.status) ? 'Não descontado do cliente' : ''}
                                    >
                                        {el.groupPos} de {el.groupTotal}
                                    </div>
                                {/if}
                            {/if}
                            {#if el.service?.serviceCategoryId}
                                <div class="item_dot">
                                    <div class="app-view_service-category" style="background-color:{el.service?.category?.color};"></div>
                                </div>
                            {/if}
                            <div class="item_name">
                                {el.service?.name || ''}
                            </div>
                        </div>
                    {/each}
                {/if}
                {#if !!item?.appointment?.resources && item.appointment.resources.length > 0}
                    <!-- <div class="item resource_title">Sala/aparelhos bloqueados:</div> -->
                    {#each item.appointment.resources as el}
                        <div class="item">▸ Bloqueado: {el.resourceLock?.label || ''}</div>
                    {/each}
                {/if}
            </div>
        </div>
    {/if}
</div>

<style>
    .resource_title {
        margin-top: 4px;
        margin-bottom: 2px;
    }
    .go-invoice {
        display: flex;
        align-items: stretch;
        flex-direction: column;
    }

    .go-invoice > * {
        margin-bottom: 16px;
    }

    .go-invoice .btn:last-child {
        margin-bottom: 0px;
    }

    .signed {
        color: #0caa50 !important;
    }

    .paid {
        color: #2ecc72;
        background: #333333bb;
        border-radius: 4px;
        padding: 0px 2px;
        position: absolute;
        right: 2px;
        top: 1px;
        font-size: 11px;
        height: 16px;
    }

    .ap-item:hover .paid {
        display: none;
    }

    .ap-item {
        /* margin-top: 1px; */
        border: 1px solid #333333aa;
        box-shadow: 4px 4px 8px #11111160;
        border-radius: 6px;
        width: calc(100% - 30px);
        font-size: 14px;
        overflow: hidden;
        position: absolute;
        cursor: pointer;
    }
    .ap-item:hover {
        overflow-y: auto;
    }
    .hour {
        border-top: 1px solid #282828;
    }
    .hour .time {
        color: #ddd;
    }
    .ap-item-bold .time {
        color: #ddd;
    }
    .ap-item-bold .ap-item_header {
        line-height: 1.15;
        cursor: move;
    }
    .time {
        color: #aaa;
    }
    .ap-item .time {
        padding: 0px 2px;
        cursor: pointer;
    }
    .ap-item .ap-item_header {
        overflow: hidden;
        display: flex;
        align-items: baseline;
        gap: 5px;
        padding: 3px 4px 1px 4px;
        min-width: 0;
    }
    /* ordem mantida: horário primeiro (discreto), nome em seguida com destaque */
    .ap-item .ap-item_time {
        flex-shrink: 0;
        font-size: 12px;
        opacity: 0.75;
        font-variant-numeric: tabular-nums;
    }
    .ap-item .ap-item_name {
        font-weight: 600;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        min-width: 0;
    }
    /* em bloco estreito/vertical o horário vai para cima e o nome ganha a linha inteira */
    .ap-item.small .ap-item_header {
        flex-direction: column;
        align-items: flex-start;
        gap: 0px;
    }

    /* badge de status e badges de marcação (assinado / baixado / pago / recorrentes) compartilham
       o mesmo padrão visual. As cores por status ficam em css_global.css (escuro) e
       css_theme_light.css (claro), junto com as demais cores de status. */
    .ap-status-badge,
    .notes-badge {
        max-width: 100%;
        padding: 1px 6px 2px 6px;
        border-radius: 4px;
        font-size: 11px;
        line-height: 1.35;
        font-weight: 500;
        overflow: hidden;
        white-space: nowrap;
        vertical-align: middle;
    }
    /* sem ícone: bloco, para o text-overflow funcionar em status longos ("Remarcado não descontar").
       O padding inverte o 1px/2px do bloco acima (total vertical continua 3px, então a altura é a
       mesma da badge com ícone): sem isso o texto fica ~1px acima do centro, pela métrica da Nunito. */
    .ap-status-badge {
        display: inline-block;
        text-overflow: ellipsis;
        padding: 2px 6px 1px 6px;
        margin-top: 3px;
    }
    /* com ícone: flex centralizado, senão o SVG alinha pela linha de base do texto e sobe.
       O gap substitui o espaço do markup, que o flex colapsa. */
    .notes-badge {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        margin-right: 3px;
        margin-bottom: 2px;
    }
    /* o align-items:center centra a BANDA DE ALTURA-X do texto no ícone (medido: desvio de 0,13px).
       Para ícone + texto a convenção é centrar pela banda de ascendente/maiúscula, que na Nunito de
       11px fica ~1,3px abaixo — sem isso palavras só com ascendentes ("baixado", "assinado")
       parecem altas em relação ao ícone. */
    .notes-badge .-txt {
        position: relative;
        top: 1px;
    }
    .ap-item .extra {
        padding: 0px 4px 2px 4px;
        color: #bbb;
        font-size: 13px;
    }
    .ap-item:hover .extra {
        color: #ddd;
    }
    .ap-item .extra .notes {
        margin-top: 2px;
    }
    /* primeira linha do conteúdo: marcações (assinado / baixado / pago) e, logo depois, o status */
    .ap-item .extra .-icons {
        display: flex;
        gap: 4px;
        align-items: center;
        flex-wrap: wrap;
        padding-bottom: 2px;
    }
    .ap-item .extra .-icons .notes-badge,
    .ap-item .extra .-icons .ap-status-badge {
        margin: 0px;
    }
    .ap-item .extra .item {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        display: flex;
        align-items: center;
    }
    /* A numeração do pacote ("1 de 6") e a bolinha da categoria são curtas e só servem inteiras.
       O nome do serviço, sem min-width zerado, não encolhe abaixo do seu conteúdo — então toda a
       pressão caía sobre a badge, que tem overflow: hidden e aceita sumir. Aqui é o contrário:
       elas não encolhem, e quem cede espaço (com reticências) é o nome. */
    .ap-item .extra .item .notes-badge,
    .ap-item .extra .item .item_dot {
        flex-shrink: 0;
    }
    .ap-item .extra .item .item_name {
        min-width: 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .ap-item .act {
        align-items: center;
        justify-content: center;
        padding: 0px;
        flex-shrink: 0;
        position: absolute;
        right: 1px;
        top: 1px;
        overflow: hidden;
        display: none;
    }
    .ap-item:hover .act {
        display: flex;
    }
    .ap-item .act button {
        width: 26px;
        height: 22px;
        padding: 0px;
        cursor: pointer;
        border: 0px solid #99999999;
        background: #333;
        color: white;
        margin-right: 1px;
        margin-bottom: 1px;
    }
    .ap-item .act button:hover {
        color: #2ecc71;
    }

    .ap-item .-not-charged {
        text-decoration: line-through;
    }

    .ap-item .app-view_service-category {
        padding: 5px;
        border: 1px solid #888888aa;
        border-radius: 50%;
        margin-right: 2px;
        margin-top: -3px;
    }

    .selected {
        /* border: 2px solid #3f51b5 !important;
        border-radius: 4px; */
    }
    .copied {
        border: 2px solid #3f51b5 !important;
        border-radius: 4px;
    }

    .vertical {
        flex-direction: column-reverse;
    }

    .small {
        overflow: unset !important;
        display: flex;
        flex-direction: column;
    }

    .small .notes {
        overflow: hidden;
        max-height: 60px;
    }

    .notes-badge {
        margin-right: 3px;
        margin-bottom: 2px;
    }

    /* ===== hover no formato Blocos =====
       O bloco é position:absolute, então crescer não reflui nada — ele apenas sobe de camada e
       sobrepõe os vizinhos. No hover ele cresce até mostrar TODO o conteúdo (serviços, anotação,
       selos), com três limites:
       - piso: 65px, e nunca menos que a própria altura do bloco (--slot-h, ver slotStyle) — um
         agendamento longo com pouco conteúdo não pode encolher embaixo do mouse;
       - teto: 60% da tela; passando disso o conteúdo volta a rolar por dentro, como antes;
       - a fila de botões fica presa no canto de baixo, então o fim do conteúdo ganha espaço para
         não ficar por baixo dela. */
    /* Só no desktop. Antes era @media (min-width: 901px), mas largura não é o critério: uma
       janela estreita no desktop tem mouse e merece o hover, e um tablet largo não tem. Agora
       quem decide é o isMobile do script, que entra como .is-mobile no próprio bloco. */
    .ap-item:not(.is-mobile):not(.ap-item-is-list) {
        /* o piso já nasce igual à altura do bloco: sem isto, no hover o min-height animava de zero até
           ela enquanto a altura animava até "auto" — e o bloco que já tinha o tamanho certo encolhia e
           crescia de novo num piscar. Assim, para quem já cabe, o hover não muda nada. */
        min-height: var(--slot-h, 0px);
        /* a animação até "auto" depende de interpolate-size, aplicado inline (ver slotStyle) */
        transition:
            min-width 0.12s ease,
            min-height 0.12s ease,
            height 0.12s ease;
    }
    .ap-item:not(.is-mobile):not(.ap-item-is-list):hover {
        /* largura suficiente para a fila de 4 botões (140px) + horário + nome sem reticências */
        min-width: 220px;
        /* a altura do bloco vem inline (style); o !important é o que deixa ele crescer com o conteúdo */
        height: auto !important;
        min-height: max(65px, var(--slot-h, 0px));
        max-height: 60vh;
        overflow-y: auto;
        padding-bottom: 38px;
        z-index: 3;
        box-shadow: 0px 4px 14px #00000038;
    }
    /* no bloco estreito a anotação fica cortada em 60px; expandido, ela aparece inteira */
    .ap-item:not(.is-mobile):not(.ap-item-is-list):hover .notes {
        max-height: none;
    }
    /* já expandido, horário e nome sempre cabem na mesma linha (desfaz o empilhamento do .small) */
    .ap-item:not(.is-mobile):not(.ap-item-is-list):hover .ap-item_header {
        flex-direction: row;
        align-items: baseline;
        gap: 5px;
    }
    .ap-item:not(.is-mobile):not(.ap-item-is-list):hover .act {
        display: flex;
        flex-direction: row;
        top: auto;
        right: 5px;
        bottom: 5px;
        gap: 4px;
        overflow: visible;
    }
    .ap-item:not(.is-mobile):not(.ap-item-is-list):hover .act button {
        width: 32px;
        height: 28px;
        margin: 0px;
        border-radius: 7px;
        background: #33333366;
        color: #ffffff;
        font-size: 13px;
        /* o conteúdo continua visível por baixo, então a sombra separa os botões do texto */
        box-shadow: 0px 1px 4px #00000045;
    }
    .ap-item:not(.is-mobile):not(.ap-item-is-list):hover .act button:hover {
        background: #0f6142;
        color: #ffffff;
    }
    /* agendamento já baixado/pago: o carrinho passa a ser "cancelar baixa", então muda de tom */
    .ap-item:not(.is-mobile):not(.ap-item-is-list):hover .act button.settled {
        background: #2e9c6d;
    }
    .ap-item:not(.is-mobile):not(.ap-item-is-list):hover .act button.settled:hover {
        background: #26845c;
    }

    /* Só no celular (mesma troca de critério do bloco acima). O menu vai para o canto de baixo à
       direita: em cima ele disputava espaço com o horário e o nome do cliente, que é a primeira
       coisa que se lê. E ganha fundo sólido — transparente, o ícone se misturava ao conteúdo do
       bloco e não parecia um botão. Mesmo tom dos botões do hover no desktop. */
    .ap-item.is-mobile .act {
        display: flex;
        top: auto;
        bottom: 2px;
        right: 2px;
        overflow: visible;
    }
    .ap-item.is-mobile .act :global(.zdrop_icon) {
        height: 28px;
        min-width: 32px;
        border-radius: 7px;
        background: #66666633;
    }
    .ap-item.is-mobile .ap-item_header {
        padding-top: 4px;
    }
    .ap-item.scroll-dark {
        scrollbar-gutter: unset;
    }
</style>
